import type { AxiosResponse } from 'axios'
import i18n from '@/i18n'

const langsMap = {
  'zh_CN': 'zh',
  'en_US': 'en',
  'ja_JP': 'ja',
} as const;

export default (response: AxiosResponse) => {
  const lang = langsMap[i18n.language as keyof typeof langsMap] || 'zh';
  const cloneI18nProps = (params: any) => {
    switch (Object.prototype.toString.call(params)) {
      case '[object Array]': {
        return params.map(cloneI18nProps)
      }
      case '[object Object]': {
        let translation: Record<string, string> = {}
        const langKey = ['langExt']
        langKey.forEach(key => {
          if(params[key]) {
            const langExtJson = JSON.parse(params[key])
            Object.assign(translation,langExtJson[lang])
          }
        })
        try {
          Object.keys(params).forEach(key => {
            if (langKey.indexOf(key) < 0) {
              if (params[key] && typeof params[key] === 'object') {
                params[key] = cloneI18nProps(params[key])
              } else {
                params[key] = translation[key] || params[key]
              }
            }
          })
          return params
        } catch (error) {
          console.error('i18n middlewares cloneI18nProps error', error, { translation, params })
          return params
        }

      }
      default: {
        return params;
      }
    }
  }
  try {
    const newData = cloneI18nProps(response.data)
    response.data = newData;
  } catch (error) {
  }
  
  return response;
}